<template>
  <v-container fluid grid-list-md>
    <v-tabs>
      <v-tab ripple>Clients</v-tab>
      <v-tab ripple>Pointage</v-tab>
      <v-tab ripple>Pointage prévisionnel</v-tab>
      <v-tab ripple>Trigrammes inactifs</v-tab>
      <v-tab ripple>Signature électronique</v-tab>
      <v-tab-item>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 lg9>
              <UsersTable />
            </v-flex>
            <v-flex xs12 lg3>
              <ReportsList />
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <BillingReviewer />
      </v-tab-item>
      <v-tab-item>
        <BillingPreview />
      </v-tab-item>
      <v-tab-item>
        <InactiveTrigram />
      </v-tab-item>
      <v-tab-item>
        <ElectronicSignature />
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>
<script>
import InactiveTrigram from "@/components/admin/InactiveTrigram";
import BillingReviewer from "../components/admin/BillingReviewer";
import BillingPreview from "@/components/admin/BillingPreview";
import UsersTable from "../components/UsersTable";
import ReportsList from "../components/ReportsList";
import ElectronicSignature from "../components/admin/signature/Main";

export default {
  components: {
    InactiveTrigram,
    UsersTable,
    ReportsList,
    BillingReviewer,
    BillingPreview,
    ElectronicSignature
  }
};
</script>
